export enum EAllMasterNames {
    PRICE_LIST = 'price_list',
    LEDGER_USER = 'ledger_user',
    ORDER_HISTORY_USER = 'order_history_user',
}
